import {Api, apiFetch} from "../_helpers/api";
import {createQueryParameters, to_url} from "../_helpers/utils";
import {StyleState} from "../_definitions/styleteq";
declare const fetch;

const CommentRepository = {
    getByStyleId: (id: number = null) => {
        return fetch(to_url(Api.apiBaseUrl, `styles/${id}/comments`), {
            credentials: "same-origin",
            headers: {
                "Accept": "application/json"
            },
        }).then(response => {
            return response.json();
        });
    },
    getByStyleId2: (id: number, page: number = null, perPage: number = 10) => {
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, `styles/${id}/comments`) + query)
            .then(response => {
                return response.json();
            });
    }
};

export default CommentRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/commentRepository.ts